<template>
    <div class="reset-password">
        <div class="container">
            <div class="brand-content">
                <img src="https://static.bienparabien.com/img/Logo_BPB_alt.png" alt="Logo BpB" width="200px">
                <h1>Restablecer contraseña</h1>
                <p>Personaliza tu contraseña para poder entrar a tú portal.</p>
            </div>
            <div>
                <form @submit.prevent="onSubmit">
                    <div class="form-group">
                        <label for="inputNewPassword" class="col-form-label"><small>Contraseña nueva</small></label>
                        <input v-model="credenciales.password" type="password" class="form-control" id="inputNewPassword">
                    </div>
                    <div class="form-group">
                        <label for="inputConfirmNewPassword" class="col-form-label"><small>Confirmar
                                contraseña</small></label>
                        <input v-model="credenciales.password_confirmation" type="password" class="form-control"
                            id="inputConfirmNewPassword">
                    </div>
                    <br />
                    <div class="form-group">
                        <button class="btn btn-bpb-primary btn-block">Aceptar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import apiAccount from '@/api/account';

export default {
    data() {
        return {
            credenciales: {
                password: null,
                password_confirmation: null,
                hash: null
            }
        }
    },
    methods: {
        async onSubmit() {
            if (!this.credenciales.password) {
                return this.$swal('Error', 'El campo contraseña es requerido', 'error');
            } else if (this.credenciales.password.length < 5) {
                return this.$swal('Error', 'La contraseña debe ser mayor o igual a 5 caracteres', 'warning');
            } else if (this.credenciales.password != this.credenciales.password_confirmation) {
                return this.$swal('Error', 'La contraseña y la confirmación no son iguales', 'error');
            }
            try {
                this.credenciales.hash = this.$route.params.hash;
                await apiAccount.recuperar_password_confirm(this.credenciales);
                this.$swal({
                    title: 'Éxito',
                    icon: 'success',
                    text: `Tu contraseña se ha actualizado correctamente.
                           Por favor, toma nota de tu nueva contraseña y dirígete a 
                           tu aplicación de clientes para iniciar sesión con ella`,
                    preConfirm: () => {
                        this.$router.push({ name: 'Home' });
                    }
                }
                );
            } catch (e) {
                this.$log.info('err', e);
                this.$swal('Error', 'Error al intentar cambiar la contraseña: ' + e.message, 'error');
            }
        }
    },
}
</script>